import axios from '../../http'

class DBHome {
  // 获取商城基础信息
  getXBBasicInformation() {
    const url = `/api/index/setting`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB用户首页月周日订单统计
  postDBOrderCount() {
    const url = '/api/db/order/dwm/count'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // DB用户首页月周日待处理订单统计
  getDBOrderUntreated() {
    const url = '/api/db/order/untreated/count'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // DB用户首页其他商品数量信息
  getDBGoods() {
    const url = '/api/goods/home/page/uda'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // DB用户首页其他客户数量信息
  getDBCustomer() {
    const url = '/api/db/cus/count/dma'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB用户获取可剩余验证码数
  postDBSmsNumber() {
    const url = '/api/db/warning'
    return axios.post(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取消息通知
  getDBNotice(currentPage) {
    const url = `/api/db/notice?currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 读取消息
  postDBReadNotice(data) {
    const url = `/api/db/notice/read`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBHome;
